<template>
  <div class="header_container" v-if="!isPreview && m_event !== null">
    <div class="header">
      <div class="toggle-menu">
        <div class="icon" @click.stop="drawer = !drawer">
          <v-icon size="20px" class="btn_item" color="rgb(232, 50, 13)">{{
            menuIcon
          }}</v-icon>
        </div>
        <div class="logo-responsive">
          <router-link :to="pathHome">
            <img :src="m_event !== null ? m_event.logo_img : logoImg" alt />
          </router-link>
        </div>
      </div>

      <div class="redLine"></div>

      <div class="btn_group pt-1">
        <div class="btn_group_sub">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="btn_item btn_item_dropdown"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                v-if="dataLanguage.length > 1"
              >
                {{ select }}
                <v-icon class="icon-language">{{ arrowDown }}</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in dataLanguage"
                :key="index"
                v-on:click="changeLanguage(item.lang_code, item.lang_name)"
              >
                <v-list-item-title>{{ item.lang_name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>

    <v-dialog v-model="dialog" max-width="520">
      <v-card class="dialog-container">
        <v-icon color="#E8320D" class="close-icon" @click="handleCloseDialog">{{
          closeIcon
        }}</v-icon>
        <div class="dialog">
          <h4 v-html="$t('header.notify-logout', { split: '/' })"></h4>
          <v-card-actions>
            <v-btn
              class="btn-logout"
              depressed
              color="#e8320e"
              @click="handleLogout"
            >
              <!-- <router-link tag="span" :to="pathDefault"> -->
              {{ $t('header.btn-logout', { split: '/' }) }}
              <!-- </router-link> -->
            </v-btn>

            <v-btn @click="handleCloseDialog" outlined color="#e8320e">
              {{ $t('header.btn-cancer', { split: '/' }) }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <div class="mainLogo">
      <div class="logo">
        <router-link :to="{ name: 'login-applicant' }">
          <img v-bind:src="m_event !== null ? m_event.logo_img : logoImg" alt />
        </router-link>
        <router-link :to="{ name: 'login-applicant' }" class="home-link">
          <h2>{{ m_event !== null && m_event.event_name }}</h2>
        </router-link>
      </div>
    </div>

    <div
      :class="[banner == true ? 'banner' : 'banner-basic', bannerImage]"
      class="list-company-overlay"
    >
      <div v-if="menu" class="menu">
        <ul>
          <li :class="{ active: currentRoute == 'top' }">
            <router-link tag="li" :to="returnUrlPath('/top')">
              TOP
            </router-link>
          </li>
          <li
            :class="{
              active: currentRoute == 'list-company'
            }"
          >
            <router-link tag="li" :to="returnUrlPath('/list-company')">
              <span v-html="$t('menu.list-company', { split: '<br>' })"></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'mail-box' }">
            <router-link tag="li" :to="returnUrlPath('/mail-box')">
              <span
                v-html="
                  $t('menu.recruitment-letter', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'applications' }">
            <router-link tag="li" :to="returnUrlPath('/applications')">
              <span
                v-html="
                  $t('menu.interview-status', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'my-code' }">
            <router-link tag="li" :to="returnUrlPath('/my-code')">
              <span
                v-html="
                  $t('menu.my-code', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'profile' }">
            <router-link tag="li" :to="returnUrlPath('/profile')">
              <span
                v-html="
                  $t('menu.basic-infomation', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'entrance' }">
            <router-link tag="li" :to="returnUrlPath('/entrance')">
              <span
                v-html="
                  $t('menu.application-info', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      width="200"
      color="rgba(54, 52, 51, 0.9)"
      class="menu-side-bar"
    >
      <div class="menu-device">
        <ul>
          <li :class="{ active: currentRoute == 'top' }">
            <router-link tag="li" :to="returnUrlPath('/top')">
              TOP
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'list-company' }">
            <router-link tag="li" :to="returnUrlPath('/list-company')">
              <span v-html="$t('menu.list-company', { split: '<br>' })"></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'mail-box' }">
            <router-link tag="li" :to="returnUrlPath('/mail-box')">
              <span
                v-html="
                  $t('menu.recruitment-letter', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'applications' }">
            <router-link tag="li" :to="returnUrlPath('/applications')">
              <span
                v-html="
                  $t('menu.interview-status', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'my-code' }">
            <router-link tag="li" :to="returnUrlPath('/my-code')">
              <span
                v-html="
                  $t('menu.my-code', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'profile' }">
            <router-link tag="li" :to="returnUrlPath('/profile')">
              <span
                v-html="
                  $t('menu.basic-infomation', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'entrance' }">
            <router-link tag="li" :to="returnUrlPath('/entrance')">
              <span
                v-html="
                  $t('menu.application-info', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
        </ul>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {
  mdiBell,
  mdiFacebook,
  mdiEarth,
  mdiEmail,
  mdiChevronDown,
  mdiMenu,
  mdiClose
} from '@mdi/js';

import { Trans } from '@/plugins/translation.js';

import {
  LANG_CODE_VIETNAMESE,
  LANG_VIETNAMESE_TITLE,
  LANG_CODE_JAPANESE,
  LANG_JAPANESE_TITLE
} from '@/common/constants';

export default {
  props: {
    isPreview: {
      default: false
    },
    mEvent: {
      type: Object
    }
  },

  data: () => ({
    bellIcon: mdiBell,
    fbIcon: mdiFacebook,
    webIcon: mdiEarth,
    mailIcon: mdiEmail,
    menuIcon: mdiMenu,
    closeIcon: mdiClose,
    arrowDown: mdiChevronDown,
    title: 'TOP',
    menu: true,
    bannerImage: '',
    currentRoute: 'homepage',

    isActive: false,

    drawer: null,
    banner: false,
    dialog: false,
    logoImg: `/image/logoMain.svg`
  }),

  watch: {
    '$route.name': function () {
      this.currentRoute = this.$route.name;
      this.initHeader();
    }
  },

  methods: {
    initHeader() {
      switch (this.$route.name) {
        case 'top':
          this.title = 'TOP';
          this.bannerImage = 'top-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'company-detail':
          this.title = 'menu.company-detail';
          this.bannerImage = 'company-detail-page';
          this.menu = false;
          this.banner = false;
          break;
        case 'list-company':
          this.title = 'menu.list-company';
          this.bannerImage = 'list-company-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'mail-box':
          this.title = 'menu.recruitment-letter';
          this.bannerImage = 'mail-box-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'applications':
          this.title = 'menu.recruitment-status';
          this.bannerImage = 'applications-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'profile':
          this.title = 'menu.basic-infomation';
          this.bannerImage = '';
          // this.bannerImage = "profile-page";
          this.menu = true;
          this.banner = false;
          break;
        case 'entrance':
          this.title = 'menu.application-info';
          // this.bannerImage = "entrance-page";
          this.bannerImage = '';
          this.menu = true;
          this.banner = false;
          break;
        case 'my-code':
          this.title = 'menu.my-code';
          this.bannerImage = '';
          // this.bannerImage = "my-code-page";
          this.menu = true;
          this.banner = false;
          break;
        case 'list-company-preview':
          this.title = 'menu.list-company';
          this.bannerImage = 'list-company-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'event-schedule-preview':
          this.title = 'menu.list-company';
          this.bannerImage = 'top-page';
          this.menu = true;
          this.banner = true;
          break;
      }
    },

    toggleMenu() {
      this.isActive = !this.isActive;
    },

    checkCurrentLanguage() {
      const lang = localStorage.getItem('sekisho_lang')
        ? localStorage.getItem('sekisho_lang')
        : 'jp_en';
      this.select =
        lang == LANG_CODE_JAPANESE
          ? LANG_JAPANESE_TITLE
          : LANG_VIETNAMESE_TITLE;

      this.changeLanguage(lang, this.select);
      if (lang !== null) {
        const langActive = this.dataLanguageFromServer.filter(
          (language) => language.lang_code === lang
        );

        this.select = langActive.length > 0 ? langActive[0].lang_name : '';
      }
    },

    handleLogout() {
      const key = this.$store.state.contract_id + this.$store.state.event_code;
      const event =
        localStorage.getItem(key) !== null ? localStorage.getItem(key) : null;

      if (event !== null) {
        this.$store.dispatch('logout');
        this.$router.push(this.pathDefault);
      }
    },

    handleShowDetail() {
      this.dialog = true;
    },
    handleCloseDialog() {
      this.dialog = false;
    },

    returnUrlPath(url) {
      const route = this.pathHome + url;

      return route;
    },

    changeLanguage(lang, title) {
      this.$store.dispatch('changeLanguage', { lang });
      localStorage.setItem('sekisho_lang', lang);
      Trans.changeLanguage(lang);
      this.select = title;
    }
  },

  created() {
    this.currentRoute = this.$route.name;
    this.initHeader();
    this.checkCurrentLanguage();
  },

  computed: {
    checkSurveyDisplay: function () {
      if (this.surveyTemplate !== null) {
        const { applicant_survey_period_from, applicant_survey_period_to } =
          this.surveyTemplate;

        const checkDate = this.getNowDateString();

        if (
          applicant_survey_period_from !== null &&
          applicant_survey_period_to !== null
        ) {
          const check = this.checkBetweenDate(
            applicant_survey_period_from,
            applicant_survey_period_to,
            checkDate
          );
          return check;
        }
      }
      return false;
    }
  },

  mounted() {
    if (this.$route.name === 'list-company-preview') {
      const { query } = this.$route;
      if (query) {
        const { language } = query;
        if (language) {
          if (language === 'jp_en') {
            this.changeLanguage(LANG_CODE_JAPANESE, LANG_JAPANESE_TITLE);
          }
          if (language === 'vi') {
            this.changeLanguage(LANG_CODE_VIETNAMESE, LANG_VIETNAMESE_TITLE);
          }
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/scss/components/header.scss';
.list-company-overlay {
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>
<style lang="scss" scoped>
.mainLogo {
  min-height: 90px !important;
  .logo h2 {
    max-width: 80vw;
  }

  .logo:not(:has(img)) h2 {
    padding: 15px 0 5px 50px;
    max-width: 85vw;
  }
}
</style>
